import { Navigate } from "react-router-dom";
import { useAuth } from "@/portal/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy" data-testid="portal-loading">
        <Loader2 className="h-8 w-8 animate-spin text-energy" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}
